import { ApiRequestOptions } from '@api/core/ApiRequestOptions';
import { getRequestOptions } from '@api/core/utils';

import type { SessionViewModel } from '../models/SessionViewModel';
import type { CancelablePromise } from '../core/CancelablePromise';
import { request as __request } from '../core/request';

export class ParametersService {
  /**
   * Session
   * Session parameters for client
   * @returns SessionViewModel Success
   * @throws ApiError
   */
  public static async session(
    options?: Partial<ApiRequestOptions>
  ): CancelablePromise<SessionViewModel> {
    const { cookies = {}, headers = {} } = options ?? {};
    delete cookies.token;
    const result = await __request<SessionViewModel>({
      method: 'GET',
      url: `/parameters/session`,
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Server Error`,
      },
      headers: getRequestOptions(headers, 'headers'),
      cookies: { ...getRequestOptions(cookies, 'cookies') },
    });
    return result;
  }
}
